module.exports = __webpack_public_path__ + "media/3.6e4ac256.mp4";